import script from "./ResumeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeComponent.vue?vue&type=script&setup=true&lang=js"

import "./ResumeComponent.vue?vue&type=style&index=0&id=0ee87efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee87efe"]])

export default __exports__